import { IConfigurations } from '@epicuro-next/platform/configuration';

export const ANALYTICS_NAMESPACE = 'analytics';

export enum AnalyticsConfigurationKeys {
  AnalyticsHottestListConfiguration = 'analytics-hottest-list-configuration',
  AnalyticsListBasketInsightDefaultSorting = 'analytics-list-basket-insight-default-sorting',
  BestPerformingDashboard = 'best-performing-dashboard',
  EnableExtendedAnalytics = 'enable-extended-analytics',
  EnableListAnalytics = 'enable-list-analytics',
  EnableListAnalyticsBasketInsight = 'enable-list-analytics-basket-insight',
  EnableListAnalyticsByRoles = 'enable-list-analytics-by-roles',
  EnableListAnalyticsLiveViewers = 'enable-list-analytics-live-viewers',
  ProductIdFormat = 'analytics-topselling-product-id-format',
}

export interface AnalyticsConfigurations
  extends IConfigurations<AnalyticsConfigurationKeys> {
  [AnalyticsConfigurationKeys.AnalyticsHottestListConfiguration]: string;
  [AnalyticsConfigurationKeys.AnalyticsListBasketInsightDefaultSorting]: string;
  [AnalyticsConfigurationKeys.BestPerformingDashboard]: string;
  [AnalyticsConfigurationKeys.EnableExtendedAnalytics]: boolean;
  [AnalyticsConfigurationKeys.EnableListAnalytics]: boolean;
  [AnalyticsConfigurationKeys.EnableListAnalyticsBasketInsight]: boolean;
  [AnalyticsConfigurationKeys.EnableListAnalyticsByRoles]: string[];
  [AnalyticsConfigurationKeys.EnableListAnalyticsLiveViewers]: boolean;
  [AnalyticsConfigurationKeys.ProductIdFormat]: string[];
}
